import { useState } from "react";
import { motion } from "framer-motion";
import { X, PaperPlaneTilt, CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useLang } from "../context/LangContext";
import api from "../lib/api";

export const ShareModal = ({ machine, onClose }) => {
  const { t } = useLang();
  const s = t.share;
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post(`/machines/${machine.id}/share`, { recipient_email: email });
      toast.success(s.sent);
      onClose();
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(d === "recipient_undeliverable" ? s.undeliverable : d === "invalid_email" ? s.invalid : s.error);
    } finally {
      setSending(false);
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0A0F1A]/50 backdrop-blur-sm" onClick={onClose}>
      <motion.div initial={{ opacity: 0, y: 30, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 20, scale: 0.97 }}
        transition={{ ease: [0.16, 1, 0.3, 1] }} onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md bg-white rounded-md border border-slate-200" data-testid="share-modal">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <div>
            <h3 className="font-display font-bold text-xl text-[#0F172A]">{s.title}</h3>
            <p className="text-xs text-slate-500 mt-0.5">{machine.name}</p>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-[#0F172A]" data-testid="share-modal-close"><X size={20} /></button>
        </div>
        <form onSubmit={send} className="px-6 py-6 space-y-5">
          <p className="text-sm text-slate-500">{s.sub}</p>
          <div>
            <label className="block font-mono-tech text-[11px] uppercase tracking-wider text-slate-500 mb-1.5">{s.emailLabel}</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="cliente@azienda.it"
              className="w-full rounded-md border border-slate-300 px-4 py-3 text-[#0F172A] outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 transition" data-testid="share-email-input" />
          </div>
          <button type="submit" disabled={sending} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 py-3.5 text-sm font-semibold text-[#04170F] hover:bg-emerald-400 transition-colors disabled:opacity-60" data-testid="share-send">
            {sending ? <><CircleNotch size={16} className="animate-spin" /> {s.sending}</> : <><PaperPlaneTilt size={16} /> {s.send}</>}
          </button>
        </form>
      </motion.div>
    </motion.div>
  );
};
